const SECTION_INTERIOR_INSET_X = 24;
const SECTION_INTERIOR_INSET_Y = 48;

/**
 * Given the absolute grid rects of a folder's files, compute the section
 * box that wraps them: padded on all sides with extra top room for the
 * section header.
 */
export function buildSectionRectAroundSlots(
  slots: Array<{
    position: { x: number; y: number };
    width: number;
    height: number;
  }>,
): { position: { x: number; y: number }; width: number; height: number } {
  const minX = Math.min(...slots.map((s) => s.position.x));
  const minY = Math.min(...slots.map((s) => s.position.y));
  const maxX = Math.max(...slots.map((s) => s.position.x + s.width));
  const maxY = Math.max(...slots.map((s) => s.position.y + s.height));
  return {
    position: {
      x: minX - SECTION_INTERIOR_INSET_X,
      y: minY - SECTION_INTERIOR_INSET_Y,
    },
    width: maxX - minX + SECTION_INTERIOR_INSET_X * 2,
    height: maxY - minY + SECTION_INTERIOR_INSET_Y + SECTION_INTERIOR_INSET_X,
  };
}
